import { getPunteggio, addButton, addBackground, resetPunteggio, setupSceneScale } from "./utility.js";
import {
    fetchLeaderboard,
    submitScore,
    qualifiesForTop10,
    promptPlayerName,
} from "./leaderboard.js";

export function setupFinePartita(k, titolo) {
    setupSceneScale();
    addBackground();

    k.add([
        k.text(titolo),
        anchor("center"),
        color(0, 255, 0),
        pos(width() / 2, 10),
    ]);

    k.add([
        k.text("Il tuo punteggio è:"),
        anchor("center"),
        pos(width() / 2, 50),
    ]);

    k.add([
        color(100, 100, 150),
        k.text(String(getPunteggio()), {size: 64}),
        anchor("center"),
        pos(width() / 2, 100),
    ]);

    const statusLabel = k.add([
        color(200, 200, 200),
        k.text("Caricamento classifica..."),
        anchor("center"),
        pos(width() / 2, 200),
    ]);

    addButton("Gioca ancora", vec2(width() / 2, height() - 120), () => {
        resetPunteggio();
        k.go("primoLivello");
    });

    addButton("Torna alla HOME", vec2(width() / 2, height() - 220), () => {
        resetPunteggio();
        k.go("inizio");
    });

    k.onKeyPress("space", () => {
        resetPunteggio();
        k.go("primoLivello");
    });

    (async () => {
        const score = getPunteggio();

        try {
            let leaderboard = await fetchLeaderboard();

            if (qualifiesForTop10(score, leaderboard)) {
                statusLabel.text = "Complimenti, rientri in TOP 10!";
                const name = await promptPlayerName();

                if (name) {
                    try {
                        const result = await submitScore(name, score);
                        if (!result.accepted) {
                            statusLabel.text = "Hai già un punteggio migliore in classifica.";
                        } else {
                            statusLabel.text = "Punteggio salvato in classifica!";
                        }
                        leaderboard = await fetchLeaderboard();
                    } catch (submitError) {
                        statusLabel.text = submitError.message;
                    }
                } else {
                    statusLabel.text = "Classifica TOP 10";
                }
            } else {
                statusLabel.text = "Classifica TOP 10";
            }

            renderLeaderboard(k, leaderboard, score, { startY: 400, rowHeight: 32 });
        } catch (error) {
            statusLabel.text = error.message;
        }
    })();
}

export function setupSchermataClassifica(k) {
    setupSceneScale();
    addBackground();

    k.add([
        k.text("Classifica TOP 10"),
        anchor("center"),
        pos(width() / 2, 100),
    ]);

    const statusLabel = k.add([
        k.text("Caricamento classifica..."),
        anchor("center"),
        pos(width() / 2, 180),
    ]);

    addButton("Indietro", vec2(width() / 2, height() - 80), () => {
        k.go("inizio");
    });

    (async () => {
        try {
            const leaderboard = await fetchLeaderboard();
            statusLabel.destroy();
            renderLeaderboard(k, leaderboard, null, { startY: 190, rowHeight: 36 });
        } catch (error) {
            statusLabel.text = error.message;
        }
    })();
}

export function renderLeaderboard(k, leaderboard, currentScore = null, options = {}) {
    destroyAll("leaderboardEntry");

    const startY = options.startY ?? 200;
    const rowHeight = options.rowHeight ?? 36;
    const rankX = 60;
    const nameX = 120;
    const pointsX = width() - 60;

    if (leaderboard.length === 0) {
        k.add([
            k.text("Nessun punteggio registrato."),
            anchor("left"),
            pos(rankX, startY),
            fixed(),
            layer("ui"),
            "leaderboardEntry",
        ]);
        return;
    }

    const headerColor = rgb(200, 200, 200);

    k.add([
        k.text("Pos"),
        anchor("left"),
        pos(rankX, startY),
        color(headerColor),
        fixed(),
        layer("ui"),
        "leaderboardEntry",
    ]);
    k.add([
        k.text("Nome"),
        anchor("left"),
        pos(nameX, startY),
        color(headerColor),
        fixed(),
        layer("ui"),
        "leaderboardEntry",
    ]);
    k.add([
        k.text("Punti"),
        anchor("right"),
        pos(pointsX, startY),
        color(headerColor),
        fixed(),
        layer("ui"),
        "leaderboardEntry",
    ]);

    leaderboard.forEach((entry, index) => {
        const points = entry.points ?? entry.score ?? 0;
        const isCurrentScore = points === currentScore;
        const rowColor = isCurrentScore ? rgb(255, 220, 0) : rgb(255, 255, 255);
        const y = startY + rowHeight + index * rowHeight;
        const name = String(entry.name ?? "Anonimo").slice(0, 18);

        k.add([
            k.text(`${entry.rank}.`),
            anchor("left"),
            pos(rankX, y),
            color(rowColor),
            fixed(),
            layer("ui"),
            "leaderboardEntry",
        ]);
        k.add([
            k.text(name),
            anchor("left"),
            pos(nameX, y),
            color(rowColor),
            fixed(),
            layer("ui"),
            "leaderboardEntry",
        ]);
        k.add([
            k.text(String(points)),
            anchor("right"),
            pos(pointsX, y),
            color(rowColor),
            fixed(),
            layer("ui"),
            "leaderboardEntry",
        ]);
    });
}
